// extracted by mini-css-extract-plugin
module.exports = {"typeCell":"typeCell__rbDp+","documentType":"documentType__9EakB","badge":"badge__2N9q4"};